import { createTheme } from "@mui/material";
const PwText = "Password";
const pwsText = "Passwords";

export const patterns = {
  //email regex pattern
  email:
  /^(?!.*\.\.)(?!.*--)(?!^\s)(?!^\-)(?!^\.)[a-zA-Z0-9!#$%&'*+/=?^_{|}~().,:;<>[\]\\" -]+(?<!-)(?<!\.)@([a-zA-Z0-9 ]+(?:-[a-zA-Z0-9 ]+)*)(\s*\.\s*[a-zA-Z]{2,})$/,
  //proposed phone number
  phoneNumber: /^\+?\d+$/,
  // username regex pattern
    username: 
      /^[a-zA-Z0-9@._-]+$/,
  //username not starts with numbers or special characters
    usernameStartWithAlphabets:
      /^[a-zA-Z][a-zA-Z0-9@._-]*$/,
    consecutiveDotsDashesUnderscores: 
      /^(?!.*(\.\.\.|---|___|@@@))/,
  // only Numbers
    onlyNumbers: 
      /^[0-9]+$/,
    alphabetSpace:
      /^[a-zA-Z]+(?: [a-zA-Z]+)*$/,
  //password regex pattern
    password:
      /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s)./,
    upperCasePassword:
      /^(?=.*[A-Z])/,
    lowerCasePassword:
      /^(?=.*[a-z])/,
    oneNumbers:
      /^(?=.*\d)/,
    oneSpecialCharacter:
      /[!@#$%^&*()_+\-=[\]{};':"\\|,`~.<>/?]+/,
    //only alphanumeric and space
    alphaNumericSpace:
    /^[a-zA-Z0-9]*(?: [a-zA-Z0-9]+)*$/,
    //only alphabets and numbers
    alphaNumeric:
    /^[a-zA-Z0-9]+$/,
    //only aplhanumeric
    onlyAlphaNumeric:
    /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]+$/,
    websiteRegex:
     /^(https?:\/\/)?(www\.)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(:\d+)?(\/[^\s]*)?$/i,
    fileNameLengthRegex: /^.{1,100}$/,
    quizNameLengthRegex: /^.{1,100}$/,
    descriptionLengthRegex: /^.{1,150}$/,
    fileNameRegex: /^(?!.* {2})[a-z0-9.\-_ ]+$/i,
    consecutiveSpecialCharsRegex: /([@.\-_]){2,}/,
    filenameAtleast1Alpha:/[a-z0-9!@#$%^&*()_+{}\[\]:;"'<>,.?\/\\|-]/i,
    startingWithSpaces: /^(?!\s)[\s\S]*$/,
    alphabetAndNumber: /^[a-zA-Z0-9]+(?: [a-zA-Z0-9]+)*$/,
    NotStartWithNumber:/^(?!\d).*$/,
    phone : /^\d{10}$/
  };
  
  export const messages = {
    // validate messages
    fullname: "Full name is required",
    username: "Username is required",
    name: "Name is required",
    subject: "Main Subject is required",
    validName: "Name must only contain alphabets",
    validFullName: "Full name must only contain alphabets",
    validSubject: "Subject must only contain alphabets",
    firstName: "First Name is required",
    lastName: "Last Name is required",
    email: "Email is required",
    role: "Role is required",
    password: `${PwText} is required`,
    confirmPassword: "Confirm Password is required",
    validUsername: "Username must contain alphanumeric characters, '@', '.', '-', and '_'",
    noConsecutiveDotsDashesUnderscores: "Username cannot contain more than two consecutive '@', '.', '-', or '_'",
    validEmail: "Enter a valid email",
    invalidUsername: "Enter a valid username",
    invalidPassword: "Enter a valid password",
    invalidWebsite: "Enter a valid website",
    invalidDescription: "Enter a valid description",
    usernameMinLength: "Username should be atleast 6 characters",
    usernameMaxLength: "Username should not exceed 50 characters",
    validPassword:
      `${PwText} must contain atleast one uppercase letter, lowercase letter, number and special character`,
    passwordMatch: `${pwsText} must match`,
    passwordMinLength: `${PwText} should be atleast 8 characters`,
    passwordMaxLength: `${PwText} should not exceed 30 characters`,
    passwordOneUpperCase: `${PwText} must have atleast one uppercase letter`,
    passwordOneLowerCase: `${PwText} must have atleast one lowercase letter`,
    passwordOneNumber: `${PwText} must have atleast one number`,
    passwordOneSpecialCharater: `${PwText} must have atleast one special character`,
    schoolName: "Schoolname is required",
    validClassroomName:"Name must contain alphabets or alphanumeric characters",
    ClassroomNameNotStartWithNumber:"Name must not start with a number",
    title:"Title must contain alphabets or alphanumeric characters",
    titleNotStartWithNumber:"Title must not start with a number",
    titleLength:"Title must be between 1 and 100 characters long",
    validCode:"Code must only contain alphanumeric characters",
    website: "Website is required",
    usernameStartWithAlphabets:"Username must start with alphabets",
    fileNameLength:"File title must be between 1 and 100 characters long",
    subjectLength:"Subject must be between 1 and 100 characters long",
    authorNameLength:"Author name must be between 1 and 100 characters long",
    descriptionLength: "Description must be between 1 and 150 characters long",
    fileName:"File title may contains only alphabets, numbers, '-', '_', '.'",
    authorName:"Author name may contains only alphabets, numbers, '-', '_', '.', '@'",
    consecutiveSpecialChars: "File title must not contain consecutive special characters",
    authorNameConsecutiveSpecialChars: "Author name must not contain consecutive special characters",
    filenameAtlease1Alpha: "File title must contain at least one alphabet",
    authorNameAtlease1Alpha: "Author name must contain at least one alphabet",
    quizName: "Quiz name is required",
    option: "Option is required",
    question: "Question is required",
    validOption: "Enter a valid Option",
    validQuestion: "Enter a valid Question",
    validQuizName: "Enter a valid Quiz Name",
    quizNameLength:"Quiz title must be between 1 and 100 characters long",
    quizNameContaines:"Quiz title may contains only alphabets, numbers, '-', '_', '.', '@'",
    quizConsecutiveSpecialChars: "Quiz title must not contain consecutive special characters",
    quiznameAtlease1Alpha: "Quiz title must contain at least one alphabet",
    LessonsTopic:"Lessons topic must contain alphabets or alphanumeric characters",
    VideoCategory:"Video category must contain alphabets or alphanumeric characters",
    LessonsTopicNotStartNumber: "Lessons topic must not start with a number",
    VideoCategoryNotStartNumber: "Video category must not start with a number",
    desription: "Description is required",
    desriptionLength: 'Description must be within 250 characters',
    titleRequired: "Title is required",
    meetingType: "Title is required",
    meetingTypeCharacter:"Title must contain alphabets or alphanumeric characters",
    meetingTypeNotStartWithNumber:"Title must not start with a number",
    meetingTypeLength:"Title must be between 1 and 100 characters long",
    validPhone : "must be 10 digits",
    requiredPhone : "Phone number is required",
    messages : 'Message is required',
    notificationdisable : "Enable notifications in the settings to view the notifications",
    validReferralCode:"Referral code must only contain alphanumeric characters",
    phoneNumberLength : "Phone number must contain a maximum of 20 digits",
    phoneNumberLength16 : "Phone number must contain a maximum of 16 digits  if not starts with '+'.",
    validPhoneNumber: "Phone number should be numeric and may include an optional '+' at the start.",
    meetingStartTime: "Start time must be at least 7 minutes in the future",
  };
  
  export const SCHOOL_ADMIN = 'schooladmin';
  export const TEACHER_ROLE = 'teacher';
  export const STUDENT_ROLE = 'student';
  export const FACILITATOR = 'facilitator';
  export const PARTICIPANT = 'participant';
  export const PTA_ROLE = 'pta';
  export const NO_DATA_FOUND = 'No Data Found';
  export const CHIME = 'CHIME';
  export const JITSI = 'JITSI';
  export const WEEKLY_CLASS = 'weekly class';
  export const ONE_ON_ONE_CLASS = '1 on 1 class';
  export const REMEDIAL_CLASS = 'remedial class';
  export const VIRTUAL = 'VIRTUAL';
  export const PHYSICAL = 'PHYSICAL';
  export const JIBRI = 'JIBRI';
  export const BOT = 'BOT';
  export const VIRTUAL_S3_PATH = 'katon-virtualschool/';

// To show advertisement image based on component
// const {classroomTabAdImage, rightSideAdFour} = images;
//   export const rightSideAdImages = [
//     rightSideAdFour,
//     rightSideAdFour,
//     classroomTabAdImage,
//     rightSideAdFour
//   ]


  export const theme= createTheme({
    components: {
      MuiBackdrop: {
        styleOverrides: {
          root: {
            backgroundColor: "rgba(0,0,0,0.2)",
          },
        },
      },
    }}
  )

export const mediaServerUrl = process.env.REACT_APP_MEDIA_SERVER_URL;

export const selectRemedialClass = `This portal is for SHS students only. Are you an SHS student preparing to seat for WAEC?`;

export const  ALERT_MESSAGE_TWO_USERS= `You can only join the meeting from two devices. Please disconnect one device to join from this device.`